module.exports = __webpack_public_path__ + "img/banner-mapna.2f6c558.webp";